<template>
    <Mainpage :storeid="storeid"
      ><div class="main-section__wrapper">
        <h2 class="title2 text-center mt-5">Thank you</h2>
        <p class="body text-center mt-4">
          A request has been sent. Please check your email to see the status of
          your order
        </p>
        <div class="text-center">
          <router-link :to="{name:'giftstore'}">
            <button
              class="btn btn-primary mt-2"
              :style="{ backgroundColor: '#3862eb' }"
            >
              Continue Ordering
            </button></router-link
          >
        </div>
        <GiftcardFooter class="mt-4"/>
        </div>
        </Mainpage>

</template>

<script lang="ts">

import GiftcardFooter from "./GiftCardFooter.vue";
import Mainpage from "./Mainpage.vue";
import { mapMutations } from "vuex";

export default {
  components: { GiftcardFooter, Mainpage },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
};
</script>

<style scoped>
.footer-wrapper {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  height: 6rem;
  width: 100%;
}
.main-section__wrapper {
  height: 92%;
  width: 100%;
  padding: 2% 20%;
  box-sizing: border-box;
}



@media only screen and (max-width: 900px) {
  .main-section__wrapper {
    margin-top: 4rem;
    padding: 1rem 1rem;
  }
  .btn-block {
    width: 100%;
  }
}
</style>
